<mat-card class="card">
  <mat-card-header (click)="navigateToProjectPage()">
    <div mat-card-avatar class="header-avatar-wrap">
      <mat-progress-spinner
        class="header-progress"
        mode="determinate"
        [diameter]="headerSpinnerDiameter"
        [strokeWidth]="4"
        [value]="statusProgress(project.status)"
        [matTooltip]="project.status"
        [attr.aria-label]="'Project status: ' + project.status"
      />
    </div>
    <mat-card-title>
      {{project.name}}
      @if (showPrivateBadge && project.visibility === Visibility.hidden) {
        <span class="private-badge" aria-label="Private project">Private</span>
      }
      @if (project.visibility === Visibility.personal) {
        <span class="private-badge personal-badge" aria-label="Personal project">Personal</span>
      }
      <span class="spacer"></span>
    </mat-card-title>
  </mat-card-header>
  @if ((project.categories ?? []).length > 0) {
    <mat-card-actions class="tags-row tags-row--categories">
      @for (cat of project.categories ?? []; track cat) {
        <mat-chip
          class="chip-category"
          (click)="toggleCategoryFilter(cat); $event.stopPropagation()"
          [ngClass]="{ 'chip-border': selectedCategoryFilters.includes(cat) }"
          >{{ cat }}</mat-chip
        >
      }
    </mat-card-actions>
  }
  @if ((project.tags ?? []).length > 0) {
    <mat-card-actions class="tags-row">
      @for (tag of project.tags ?? []; track tag) {
        <mat-chip
          (click)="toggleTagFilter(tag); $event.stopPropagation()"
          [ngClass]="{ 'chip-border': selectedStatusTagFilters.includes(tag) }"
          >{{ tag }}</mat-chip
        >
      }
    </mat-card-actions>
  }
  @if (listingImageUrl(project); as imgSrc) {
    <img (click)="navigateToProjectPage()" mat-card-image [src]="imgSrc" [alt]="''" />
  }
  <mat-card-content>
    <p>
      {{project.short_description}}
    </p>
  </mat-card-content>
</mat-card>